if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    async onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      const sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
      formData.append('sections', sections);
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      let releaseGiftLock;

      try {
        // The gift is never purchasable on its own.
        const rejection = window.freeGift && window.freeGift.rejectAdd(formData);
        if (rejection) {
          this.handleErrorMessage(rejection);
          return;
        }

        if (window.freeGift) releaseGiftLock = await window.freeGift.acquireAddLock();

        // Look the cart up alongside the add rather than after it, so the gift modal opens sooner.
        if (window.freeGift) window.freeGift.primeCart();

        // Add what the customer actually asked for first, so nothing downstream can lose the sale.
        const productResponse = await fetch(`${routes.cart_add_url}`, config).then((response) => response.json());
        if (productResponse.status) {
          this.handleErrorMessage(productResponse.description);
          return;
        }

        let notificationResponse = productResponse;
        const addedVariantIds = [formData.get('id')];

        if (window.freeGift) {
          // One qualifying unit earns one gift, so the gift offer needs the quantity just added.
          const addedQuantity = Math.max(1, parseInt(formData.get('quantity'), 10) || 1);
          const gift = await window.freeGift.offerGift(
            submitButton,
            sections,
            window.location.pathname,
            addedQuantity
          );

          if (gift.error) this.handleErrorMessage(gift.error);
          if (gift.response) {
            notificationResponse = gift.response;
            addedVariantIds.push(gift.variantId);
          }
        }

        notificationResponse.addedVariantIds = addedVariantIds.filter(Boolean);
        this.cartNotification.renderContents(notificationResponse);
      } catch (error) {
        this.handleErrorMessage(error.message || window.cartStrings.error);
        console.error(error);
      } finally {
        if (releaseGiftLock) releaseGiftLock();
        submitButton.classList.remove('loading');
        submitButton.removeAttribute('aria-disabled');
        this.querySelector('.loading-overlay__spinner').classList.add('hidden');
      }
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
